import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { View, StyleSheet, ViewStyle, Text } from 'react-native';

import { useAppTheme } from '../../design-system/ThemeProvider';

interface CardProps {
  children: React.ReactNode;
  style?: ViewStyle;
  variant?: 'gradient' | 'frosted' | 'solid';
}

const Card: React.FC<CardProps> = ({ children, style, variant = 'solid' }) => {
  const { colors } = useAppTheme();

  if (variant === 'gradient') {
    return (
      <LinearGradient
        colors={["#43e97b", "#38f9d7"]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={[styles.card, style]}
      >
        {children}
      </LinearGradient>
    );
  }
  if (variant === 'frosted') {
    return (
      <View style={[styles.card, styles.frosted, style]}>
        <View style={{width: '100%'}}>
          {React.Children.map(children, child => {
            if (
              React.isValidElement(child) &&
              child.type === Text &&
              child.props &&
              (child as any).props?.style &&
              (typeof (child as any).props?.style === 'object' || Array.isArray((child as any).props?.style))
            ) {
              return React.cloneElement(child, {
                style: [(child as any).props?.style, { color: '#fff' }]
              } as import('react-native').TextProps);
            }
            // Otherwise, leave unchanged
            return child;
          })}
        </View>
      </View>
    );
  }
  // fallback to solid
  return (
    <View
      style={[
        styles.card,
        styles.solid,
        {
          backgroundColor: colors.surfaceContainerLow,
          borderColor: colors.outlineVariant,
        },
        style,
      ]}
    >
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    borderRadius: 16,
    padding: 20,
    marginBottom: 18

    },
  frosted: {
    backgroundColor: 'rgba(51,129,198,0.85)', // blue frosted glass
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.18)',
    // Optional: add backdropFilter if web
  },
  solid: {
    shadowColor: '#1D1A23',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 3,
    borderWidth: 1,
  }
});

export default Card;
